import { inject } from 'inversify';
import { HttpClientType, HttpStatusCode } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

export type IExportDeclarationsExcelRepoResponse = IRepoResponse<HttpStatusCode.OK, Blob> | IRepoResponse<HttpStatusCode.BAD_REQUEST | HttpStatusCode.INTERNAL_SERVER_ERROR, string>;

export type IExportDeclarationsExcelRepo = IRepo<[number | string], IExportDeclarationsExcelRepoResponse>;

export const ExportDeclarationsExcelRepoType = Symbol.for('ExportDeclarationsExcelRepo');

@bind(ExportDeclarationsExcelRepoType)
export class ExportDeclarationsExcelRepo implements IExportDeclarationsExcelRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(id: number | string) {
    try {
      const result = await this.httpClient.get({ url: urlMaker(`/api/admin/export/declaration/download/${id}`) });

      if (result.status === HttpStatusCode.OK) {
        const blob = await result.blob?.();

        if (blob) {
          return {
            status: HttpStatusCode.OK as HttpStatusCode.OK,
            response: blob,
          };
        }

        return {
          status: HttpStatusCode.BAD_REQUEST as HttpStatusCode.BAD_REQUEST,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      } else if ([HttpStatusCode.BAD_REQUEST, HttpStatusCode.UNPROCESSABLE_ENTITY].includes(result.status)) {
        return {
          status: HttpStatusCode.BAD_REQUEST as HttpStatusCode.BAD_REQUEST,
          response: Object.values(result.data.errors).flat().join('. '),
        };
      } else {
        return {
          status: HttpStatusCode.BAD_REQUEST as HttpStatusCode.BAD_REQUEST,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: HttpStatusCode.INTERNAL_SERVER_ERROR as HttpStatusCode.INTERNAL_SERVER_ERROR,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
